import React, { Component, Fragment } from "react"
import Async from "react-select"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"
import externalLink from "../../../assets/images/external-link.png"
import ButtonIcon from "../../Costing/Button/ButtonIcon"
import { SampleServices } from "../../../services"
import Loading from "../../Common/Loading"
const trimTemplate = {
  assignedTo: "",
  trimCategory: "",
  trimRefNo: "",
  description: "",
  quality: "",
  size: "",
  status: "",
  ETA: "",
  completedDate: ""
}

const shirringTemplate = {
  trimCategory: "",
  trimRefNo: "",
  placement: "",
  type: "",
  noOfRows: "",
  length: "",
  total: ""
}

export default class TrimModule extends Component {
  state = {
    _id: "",
    trim: {},
    STATUS: [],
    TRIM: {},
    trimOptions: {},
    trimCategoryList: [],
    trimNumberList: [],
    assignedToList: [],
    disabled: false,
    durationTrim: null,
    finish: false,
    pdfLoading: false,
  }

  componentWillMount() {
    const {
      _id,
      trim,
      trimRadio,
      trimProcess,
      disabled,
      STATUS,
      assignedToList,
      trimNumberList,
      TRIM,
      TRIMPLACEMENT,
      durationTrim
    } = this.props
    this.setState({
      _id,
      trim,
      trimRadio,
      trimProcess,
      disabled,
      STATUS,
      assignedToList,
      trimNumberList,
      TRIM,
      TRIMPLACEMENT,
      durationTrim
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      trim,
      trimRadio,
      trimProcess,
      disabled,
      STATUS,
      assignedToList,
      trimNumberList,
      TRIM,
      TRIMPLACEMENT,
      durationTrim
    } = nextProps
    this.setState({
      _id,
      trim,
      trimRadio,
      trimProcess,
      disabled,
      STATUS,
      assignedToList,
      trimNumberList,
      TRIM,
      TRIMPLACEMENT,
      durationTrim
    })
  }

  // componentDidMount() {
  //   let trim = {...this.state.trim}
  //   if (!this.state.finish) {
  //     if (trim && trim.row1 && trim.row1.length > 0) {
  //       trim.row1.forEach((x, i) => {
  //         if (x.trimCategory) {
  //           SampleServices.getTrimNumber(x.trimCategory)
  //             .then(async response => {
  //               trim.row1[i].trimList = response.text.data
  //             })
  //             .catch(error => alert(error.toString()))
  //         }
  //       })
  //     }

  //     if (trim && trim.row2 && trim.row2.length > 0) {
  //       trim.row2.forEach((x, i) => {
  //         if (x.trimCategory) {
  //           SampleServices.getTrimNumber(x.trimCategory)
  //             .then(async response => {
  //               trim.row2[i].trimList = response.text.data
  //             })
  //             .catch(error => alert(error.toString()))
  //         }
  //       })
  //     }
  //     this.setState({ finish: true, trim })
  //   }
  // }

  toggleChange = () => {
    this.setState({ smocking: !this.state.smocking })
  }

  changeCount = (index, name) => {
    index === 0
      ? this.state[name].push(
        name === "trimCount" ? trimTemplate : shirringTemplate
      )
      : this.state[name].splice(index, 1)
    this.setState({ [name]: this.state[name] })
  }

  checkValidation = (data, element) => {

    if (
      this.validateArrayObject(this.props.trim.row1, "trimNumber", null) &&
      (this.validateArrayObject(this.props.trim.row1, "trimCategory", "") ||
        this.validateArrayObject(this.props.trim.row1, "trimCategory", null))
    ) {
      if (data === "save") {
        this.props.createTrim(element)
      } else {
        this.props.completeTrim(element)
      }
    } else {
      this.props.getalertMessage("error", "Please fill all mandatory fields")
    }
  }
  validateArrayObject(data, key, val) {
    let values =
      data.filter(function (x) {
        return x[key] == val
      }).length === 0
        ? true
        : false
    return values
  }

  
generatePdf = async () => {
  try {
    this.setState({ pdfLoading: true })
  // if (this.props.styleNoInfo && this.props.styleNoInfo.length > 0) 
    const response = await SampleServices.getTrimPdf(this.state._id, this.props.styleNoInfo[0].label)
  
    console.log("PDF Downloaded", response)
  } catch (error) {
    alert(error.toString())
  } finally {
    this.setState({ pdfLoading: false })
  }
}

  render() {
   const { trim, STATUS, pdfLoading } = this.state
    const { permissions } = this.props
    console.log("trim", trim)
if (this.props.styleNoInfo && this.props.styleNoInfo.length > 0) {
  console.log(this.props.styleNoInfo[0].label, "styleInfo trim")
}
  
    return (
      <div
        class="card-filter meeting-min-con"
        id="trim"
        style={{ marginBottom: ".5%" }}
      >
          {pdfLoading && <Loading />}

        <div class="col-md-12">
          <ModuleHeader
            header={"Trim "}
            durationETA={this.state.durationTrim}
            moduleName={"trim"}
            process={this.state.trimProcess}
            updateModulesMain={this.props.updateModulesMain}
            onClick={this.onOpenModal}
            generatePDF={true}
            onGeneratePDF={this.generatePdf}
            _id={this.state._id}
            disabled={this.state.disabled}
            statusList={STATUS}
          />
          <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
            <div class="wash-container">
              <div class="col-md-12 no-padding">
                <form id="trimForm">
                  <div className="col-md-12 nopadding">
                    <div class="col-md-12 nopadding">
                      <table class="table">
                        <thead class="border-bottom-0">
                          <tr class="border-bottom-0">
                            {/* <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Assigned to
                            </th> */}
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Trim Category{" "}
                              <span
                                style={{ fontSize: "1.2rem" }}
                                className="text-danger"
                              >
                                *
                              </span>
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Trim Ref no{" "}
                              <span
                                style={{ fontSize: "1.2rem" }}
                                className="text-danger"
                              >
                                *
                              </span>
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Description
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Quality
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              size
                            </th>
                            <th class="border-bottom-0 text-left" />
                            <th class="border-bottom-0 text-left" />
                            {/* <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Status
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              ETA Date
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Completed Date
                            </th> */}
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              {!this.state.disabled &&
                                (permissions.create || permissions.edit) && (
                                  <ButtonIcon
                                    buttonType="add"
                                    addRemoveFunc={() =>
                                      this.props.addTrim("row1")
                                    }
                                  />
                                )}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.trim &&
                            this.state.trim.row1 &&
                            this.state.trim.row1.length &&
                            this.state.trim.row1.map((trim, index) => (
                              <tr key={index}>
                                {/* <td class="border-top-0">
                                <div class="custom-async-select">
                                  <Async
                                    name="assignedTo"
                                    value={trim.assignedTo}
                                    // onInputChange={this.getFabricNumber}
                                    // onChange={(value) => this.props.getFabricInfo(value,index)}
                                    placeholder="Find AssignedTo"
                                    options={this.state.assignedToList}
                                    disabled={true}
                                  />
                                </div>
                              </td> */}
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="trimCategory"
                                    value={trim.trimCategory}
                                    index={index}
                                    options={this.state.TRIM.TRIMCATEGORY || []}
                                    onChange={this.props.updateTrimRow1}
                                    onInputChange={this.props.updateTrimRow1}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0" width="15%">
                                  <div class="custom-async-select inline-external">
                                    <Async
                                      name="trimNumber"
                                      // clearable={false}
                                      value={trim.trimNumber}
                                      onInputChange={value =>
                                        this.props.getTrimRefNo(
                                          trim.trimCategory,
                                          value,
                                          index
                                        )
                                      }
                                      onChange={value =>
                                        this.props.getTrimInfo(value, index)
                                      }
                                      placeholder="Find trimRefNo"
                                      options={
                                        trim.trimList ? trim.trimList : []
                                      }
                                      disabled={this.state.disabled}
                                      onSelectResetsInput={false}
                                      onBlurResetsInput={false}
                                    />
                                  </div>
                                  <img
                                    className={"external-link cursor-hover"}
                                    src={externalLink}
                                    onClick={() => {
                                      if (trim.trimNumber) {
                                        let action = this.state.disabled && 'view' || 'edit';
                                        let search = "?" + new URLSearchParams({
                                          action: action,
                                          _id: trim.trimNumber,
                                        }).toString()
                                        window.open(`/Trim${search}`, "_blank")
                                      }
                                    }
                                      // this.props.history.push("/Trim", {
                                      //   action:
                                      //     this.props.action === "add"
                                      //       ? "edit"
                                      //       : this.props.action,
                                      //   _id: trim.trimNumber
                                      // })
                                    }
                                  />
                                </td>
                                <td
                                  class="border-top-0"
                                  style={{ padding: "13px 9px" }}
                                >
                                  {/* <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="description"
                                  value={trim.description}
                                  index={index}
                                  options={
                                    this.state.TRIM.TRIMDESCRIPTION || []
                                  }
                                  onChange={this.props.updateTrimRow1}
                                  disabled={true}
                                /> */}
                                  <p>{trim.description}</p>
                                </td>
                                <td
                                  class="border-top-0"
                                  style={{ padding: "13px 9px" }}
                                >
                                  {/* <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="quality"
                                  value={trim.quality}
                                  index={index}
                                  options={this.state.TRIM.TRIMQUALITY || []}
                                  onChange={this.props.updateTrimRow1}
                                  disabled={true}
                                /> */}
                                  <p>{trim.quality}</p>
                                </td>
                                <td
                                  class="border-top-0"
                                  style={{ padding: "13px 9px" }}
                                >
                                  <div className="dis-flex">
                                    {/* <select
                                    className="form-control select-currency"
                                    name="sizeNumber"
                                    onChange={e =>
                                      this.props.updateTrimRow1(
                                        e.target.name,
                                        e.target.value,
                                        index
                                      )
                                    }
                                    disabled={true}
                                    value={trim.sizeNumber}
                                  >
                                    <option value="">---</option>
                                    {this.state.TRIM &&
                                      this.state.TRIM.TRIMSIZE1 &&
                                      this.state.TRIM.TRIMSIZE1.map(
                                        (data, index) => (
                                          <option value={data.value}>
                                            {data.label}
                                          </option>
                                        )
                                      )}
                                  </select> */}
                                    {/* <select
                                    className="form-control select-currency"
                                    name="size"
                                    onChange={e =>
                                      this.updateTrimRow1(
                                        e.target.name,
                                        e.target.value,
                                        index
                                      )
                                    }
                                    disabled={true}
                                    value={trim.size}
                                  >
                                    <option value="">---</option>
                                    {this.state.TRIM &&
                                      this.state.TRIM.TRIMSIZE2 &&
                                      this.state.TRIM.TRIMSIZE2.map(
                                        (data, index) => (
                                          <option value={data.value}>
                                            {data.label}
                                          </option>
                                        )
                                      )}
                                  </select> */}
                                    <p>{`${trim.sizeNumber}-${trim.size}`}</p>
                                  </div>
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    label="in Hse"
                                    inputType="radio"
                                    inputName={"trimRadio" + index}
                                    value={"inHsetrimRadio" + index}
                                    checked={trim.trimRadio === "inHse"}
                                    index={index}
                                    onChange={(name, value) =>
                                      this.props.updateTrimRow1(
                                        "trimRadio",
                                        "inHse",
                                        index
                                      )
                                    }
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="radio"
                                    inputName={`trimRadio${index}`}
                                    label="not In Hse"
                                    value={"notInHsetrimRadio" + index}
                                    checked={trim.trimRadio === "notInHse"}
                                    index={index}
                                    onChange={(name, value) =>
                                      this.props.updateTrimRow1(
                                        "trimRadio",
                                        "notInHse",
                                        index
                                      )
                                    }
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                {/* <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="status"
                                  value={trim.status}
                                  index={index}
                                  options={STATUS}
                                  onChange={this.props.updateTrimRow1}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="date"
                                  value={trim.ETA}
                                  inputName="ETA"
                                  index={index}
                                  onChange={this.props.updateTrimRow1}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="date"
                                  value={trim.completedDate}
                                  inputName="completedDate"
                                  index={index}
                                  onChange={this.props.updateTrimRow1}
                                  disabled={this.state.disabled}
                                />
                              </td> */}
                                <td colSpan="2" className="border-top-0" />
                                <td class="border-top-0">
                                  {!this.state.disabled &&
                                    (permissions.create ||
                                      permissions.edit) && (
                                      <ButtonIcon
                                        buttonType="clear"
                                        addRemoveFunc={() =>
                                          this.props.removeTrim("row1", index)
                                        }
                                      />
                                    )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>

                    {/* <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="smokingOrShiring"
                      value={this.state.trim.smokingOrShiring}
                      label="smocking/Shirring"
                      onChange={this.props.updateTrim}
                      disabled={this.state.disabled}
                    />

                    {this.state.trim.smokingOrShiring && (
                      <div class="col-md-12 nopadding">
                        <table class="table">
                          <thead class="border-bottom-0">
                            <tr class="border-bottom-0">
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Trim Category
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Trim Ref no
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Placement
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Type
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                No Of Rows
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Length in cm
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Total Reqrd-mtrs
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              />
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.trim.row2.map((value, index) => (
                              <tr>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="trimCategory"
                                    value={value.trimCategory}
                                    index={index}
                                    options={this.state.TRIM.TRIMCATEGORY || []}
                                    onChange={this.props.updateTrimRow2}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <div class="custom-async-select">
                                    <Async
                                      name="trimNumber"
                                      value={value.trimNumber}
                                      onInputChange={value =>
                                        this.getTrimRefNo(
                                          value.trimCategory,
                                          value
                                        )
                                      }
                                      onChange={value =>
                                        this.props.getTrimInfoRow2(value, index)
                                      }
                                      placeholder="Find trimRefNo"
                                      options={
                                        value.trimList ? value.trimList : []
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </div>
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="placement"
                                    value={value.placement}
                                    index={index}
                                    options={this.state.TRIMPLACEMENT || []}
                                    onChange={this.props.updateTrimRow2}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="type"
                                    value={value.type}
                                    index={index}
                                    options={[
                                      {
                                        label: "Both Elastic",
                                        value: "Both Elastic"
                                      },
                                      {
                                        label: "Top TTH / Bottom Elastic",
                                        value: "Top TTH / Bottom Elastic"
                                      }
                                    ]}
                                    onChange={this.props.updateTrimRow2}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="number"
                                    inputName="noOfRow"
                                    index={index}
                                    value={value.noOfRow}
                                    onChange={this.props.updateTrimRow2}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="number"
                                    inputName="length"
                                    value={value.length}
                                    index={index}
                                    onChange={this.props.updateTrimRow2}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="number"
                                    inputName="totalReq"
                                    value={value.totalReq}
                                    index={index}
                                    onChange={this.props.updateTrimRow2}
                                    disabled={this.state.disabled || true}
                                  />
                                </td>
                                <td
                                  class="border-top-0"
                                  style={{ top: "12px" }}
                                >
                                  {!this.state.disabled &&
                                    (permissions.create ||
                                      permissions.edit) && (
                                      <a
                                        className={
                                          index === 0
                                            ? "btn-floating btn-small waves-effect waves-light green pull-right"
                                            : "btn-floating btn-small waves-effect waves-light red pull-right del-tr-btn"
                                        }
                                        onClick={e =>
                                          index === 0
                                            ? this.props.addTrim("row2")
                                            : this.props.removeTrim(
                                              "row2",
                                              index
                                            )
                                        }
                                      >
                                        <i class="material-icons">
                                          {index === 0 ? "add" : "clear"}
                                        </i>
                                      </a>
                                    )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )} */}
                    <div class="col-md-11 no-padding pl-0">
                      <div class="col-md-10 step-one pl-0">
                        <Field
                          isFormGroup={true}
                          inputType="textarea"
                          inputName="comment"
                          value={this.state.trim.comment}
                          label="comments"
                          onChange={this.props.updateTrim}
                          disabled={this.state.disabled}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {!this.state.disabled && (permissions.create || permissions.edit) && (
              <div class="col-md-12 no-padding text-center profile-btn">
                <Button
                  buttonName={"save"}
                  onClick={e => this.checkValidation("save", e)}
                />
                <Button
                  buttonName={"Complete"}
                  onClick={e => this.checkValidation("complete", e)}
                />
              </div>
            )}
          </div>
          {/* } */}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/TrimModule/index.js